import React, { useState } from "react";
import axios from "axios";

const FeatureCar = () => {
  const [recordNumber, setRecordNumber] = useState("");
  const [car, setCar] = useState(null);
  const [message, setMessage] = useState("");

  const handleFetchCar = async () => {
    try {
      const res = await axios.get(
        `https://automotive-backend-production.up.railway.app/inventory/record/${recordNumber}`
      );
      setCar(res.data);
      setMessage("");
    } catch {
      setCar(null);
      setMessage("Car not found!");
    }
  };

    const handleMakeFeatured = async () => {
    try {
        const res = await axios.put(
        `https://automotive-backend-production.up.railway.app/inventory/feature/${recordNumber}`
        );
        console.log("Feature response:", res.data);
        setMessage(res.data.message);
    } catch (err) {
        console.error("Error featuring car:", err.response?.data || err.message);
        setMessage(err.response?.data?.message || "Failed to make the car featured!");
    }
    }; 


  return (
    <div className="container my-4">
      <h3>Feature a Car</h3>

      <div className="mb-3">
        <label>Enter Record Number</label>
        <input
          type="text"
          className="form-control"
          value={recordNumber}
          onChange={(e) => setRecordNumber(e.target.value)}
        />
      </div>

      <button className="btn btn-primary" onClick={handleFetchCar}>
        Fetch Car
      </button>

      {car && (
        <div className="mt-4 p-3 border rounded">
          <h5>{car.Name}</h5>
          <p>Year: {car.Year}</p>
          <p>Price: ${car.Price}</p>
          <p>Tags: {car.tags?.join(", ") || "No tags"}</p>
          <img
            src={`https://automotive-backend-production.up.railway.app/${car.Thumbnail || car.ImageURL?.[0]}`}
            alt={car.Name}
            style={{ width: "200px", marginTop: "10px" }}
          />

          <div className="mt-3">
            <button className="btn btn-success" onClick={handleMakeFeatured}>
              Mark as Featured
            </button>
          </div>
        </div>
      )}

      {message && <p className="mt-3 text-info">{message}</p>}
    </div>
  );
};

export default FeatureCar;
